import { render, staticRenderFns } from "./InsuranceNotifications.vue?vue&type=template&id=8264151a&"
import script from "./InsuranceNotifications.vue?vue&type=script&lang=js&"
export * from "./InsuranceNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports